import { Dialog, DialogTitle, IconButton, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { DialogContent } from '@mui/material';
import { DialogActions } from '@mui/material';
import { Button } from '@mui/material';
import { PinnerProModalProps } from '../../../interfaces/SettingsProp';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

const PinnerProModal: React.FC<PinnerProModalProps> = ({ open, handleClose }) => {
    const { t, i18n } = useTranslation();

    const getFormUrl = () => {
        const currentLanguage = i18n.language;
        if (currentLanguage === 'it') {
            return 'https://link.pinnalo.it/PNNRPRITA';
        } else {
            return 'https://link.pinnalo.it/PNNRPRENG'
        }
    };

    return (
        <Dialog
            fullWidth
            open={open}
            maxWidth="sm"
            onClose={handleClose}
            PaperProps={{ style: { backgroundColor: '#ffffff' } }}
        >
            <DialogTitle>
                <Typography variant="h5">{t('settings:pinner_pro')}</Typography>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ maxWidth: '100%', overflowX: 'hidden' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <Typography variant="body1">
                        {t('settings:pinner_pro_description_1')}
                    </Typography>
                    <Typography variant="body1">
                        {t('settings:pinner_pro_description_2')} <span style={{ fontWeight: 'bold' }}>{t('settings:pinner_pro_description_2_bold')}</span>
                    </Typography>
                    <Typography variant="body1">
                        {t('settings:pinner_pro_description_3')}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    onClick={() => {
                        window.open(getFormUrl(), '_blank');
                    }}
                    sx={{
                        margin: '1rem',
                        fontSize: { xs: '0.875rem', sm: '1rem' },
                        color: '#fff',
                        backgroundColor: '#E9495A',
                        '&:hover': {
                            backgroundColor: '#E9495A',
                        }
                    }}
                    fullWidth
                >
                    {t('settings:pinner_pro_button')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default PinnerProModal;